import { InternalAxiosRequestConfig } from 'axios'

import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from 'src/app-constants'
import { parseToken } from 'src/utils'

import { refresh } from './axios'

let refreshAccessTokenPendingRequest: Promise<string | undefined> | null

function isValidAccessToken(token: string | null): boolean {
  if (!token) {
    return false
  }

  const { exp } = JSON.parse(atob(token.split('.')[1]))
  const expirationDate = new Date(exp * 1000)

  return new Date() < expirationDate
}

const renewAccessToken = async (refreshToken: string) => {
  if (refreshAccessTokenPendingRequest) {
    return await refreshAccessTokenPendingRequest
  }

  refreshAccessTokenPendingRequest = refresh(refreshToken)
  const data = await refreshAccessTokenPendingRequest
  refreshAccessTokenPendingRequest = null
  return data
}

export const authInterceptor = async (config: InternalAxiosRequestConfig) => {
  if (typeof window !== 'undefined') {
    const authToken = parseToken(localStorage.getItem(ACCESS_TOKEN_KEY))
    const refreshToken = parseToken(localStorage.getItem(REFRESH_TOKEN_KEY))

    if (authToken) {
      if (!isValidAccessToken(authToken)) {
        try {
          const newAccessToken = await renewAccessToken(refreshToken)
          config.headers['Authorization'] = `Bearer ${newAccessToken}`
        } catch {
          /* empty */
        }
      } else config.headers['Authorization'] = `Bearer ${authToken}`
    }
  }

  return config
}
